module.exports = __webpack_public_path__ + "media/images/writer-offering-policy02-8339cc34c5f1eeaea1d5e4907f0bc474.png";